exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerSource a{color:#3273dc!important}", ""]);

// exports
